import React from "react";

const Cancel = ({ color = "#323232", width = 15, height = 15, ...rest }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M1.34303 1.34387C1.92881 0.758082 2.87856 0.758082 3.46435 1.34387L12.6567 10.5363C13.2425 11.122 13.2425 12.0718 12.6567 12.6576C12.0709 13.2434 11.1212 13.2434 10.5354 12.6576L1.34303 3.46519C0.75724 2.8794 0.75724 1.92965 1.34303 1.34387Z"
      fill={color}
    />
    <path
      d="M1.34325 12.6573C0.757466 12.0716 0.757466 11.1218 1.34325 10.536L10.5356 1.34364C11.1214 0.75785 12.0712 0.75785 12.657 1.34364C13.2427 1.92942 13.2427 2.87917 12.657 3.46496L3.46457 12.6573C2.87879 13.2431 1.92904 13.2431 1.34325 12.6573Z"
      fill={color}
    />
  </svg>
);

export default Cancel;
